export default "__VITE_ASSET__QcNYYbQ1__"